import React, { ReactNode } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";

const LoadingSpinner: React.FC = () => (
  <div className="flex justify-center items-center h-screen bg-gray-50">
    <div className="flex flex-col items-center gap-4">
      <div className="loading-spinner"></div>
      <span className="text-gray-600 text-sm">読み込み中...</span>
    </div>
  </div>
);

interface AdminRouteProps {
  children: ReactNode;
}

/**
 * 管理者専用ルート保護コンポーネント
 * 認証済み かつ 管理者ロールを持つユーザーのみアクセス可能
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  // 未認証の場合はログインページへリダイレクト
  if (!user) {
    return <Navigate to="/about" replace />;
  }

  // 管理者権限がない場合はダッシュボードへリダイレクト
  if (user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
